/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import {
  API,
  defaultLimitPagination,
  fileUpload,
  get,
  ProjectStatus,
} from "../../../config";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import ProjectActionButton from "./components/ProjectActionButton";
import AddProject from "./AddProject";
import { formatNumber, formatPhone, formatedAddress } from "../../common/Misc";
import ProjectSubscriptionStatus from "./components/ProjectSubscriptionStatus";
import { fetchAccountConnectionData } from "../../Project/settings/integrations/components/IntegrationsHelper";
import CustomTooltip from "../../common/CustomTooltip";
import ReactSelect from "react-select";
import XeroLogo from "../../../assets/images/xero-logo.png";
import SyncProject from "./components/SyncProject";
import SearchBox from "../../common/SearchBox";

const Projects = ({ id }) => {
  const [projectLoading, setProjectLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();

  const [searchParam, setSearchParam] = useState("");
  const [searchParamData, setSearchParamData] = useState("");
  const [showProject, setShowProject] = useState(false);
  const [headProject, setHeadProject] = useState(null);

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  const builderId = id;

  const navigate = useNavigate();

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [xeroData, setXeroData] = useState(null);
  const [isImportFromXero, setIsImportFromXero] = useState(false);
  const [isTenantData, setIsTenantData] = useState(false);
  const [XPMLoading, setXPMLoading] = useState(false);
  const [tenantData, setTenantData] = useState([]);
  const [tenantId, setTenantId] = useState();
  const xeroCode = query.get("code");

  const [xeroSelectedRowIds, setXeroSelectedRowIds] = useState([]);
  const [notXeroSelectedRowIds, setNotXeroSelectedRowIds] = useState([]);

  const [loading, setLoading] = useState(false);
  const [syncOptionModal, setSyncOptionModal] = useState(false);
  const [tentantLoading, setTentantLoading] = useState(false);
  const [syncOptionData, setSyncOptionData] = useState([]);
  const [syncOptionId, setSyncOptionId] = useState();
  const [builderProjectId, setBuilderProjectId] = useState();
  const [showImport, setShowImport] = useState(false);

  // *API Call of Subscription Products - Start
  // const [setsubscription, setsubscriptionlist] = useState([]);
  // const [supportPlan, setSupportPlan] = useState([]);
  // const [promoCode, setPromoCode] = useState(false);
  // const [defaultPromoCode, setDefaultPromoCode] = useState("");
  // const [isSubLoading, setIsSubLoading] = useState(true);
  // const [selectedPeriodPlan, setSelectedPeriodPlan] = useState("month");

  // let login = true;

  // const setsubscriptiondata = useCallback(async () => {
  //   try {
  //     setIsSubLoading(true);
  //     const { data } = await get(API.SUBSCRIPTION);
  //     let array = login
  //       ? [
  //           { type: "supportPlan", plan: [] },
  //           { type: "month", plan: [] },
  //           // { type: "year", plan: [] },
  //         ]
  //       : [
  //           { type: "month", plan: [] },
  //           // { type: "year", plan: [] },
  //         ];
  //     data.data.map((item) => {
  //       if (item?.prices?.data && item?.prices?.data?.length > 0) {
  //         item?.prices?.data?.map((pricePlan) => {
  //           if (
  //             pricePlan?.recurring?.interval === "month" &&
  //             pricePlan?.active === true
  //           ) {
  //             const nameObj = { name: item?.name, unitLabel: item?.unit_label };
  //             login
  //               ? array[1].plan.push({ ...pricePlan, ...nameObj })
  //               : array[0].plan.push({ ...pricePlan, ...nameObj });
  //           }
  //           if (
  //             pricePlan?.recurring?.interval === "year" &&
  //             pricePlan?.active === true
  //           ) {
  //             const nameObj = { name: item?.name, unitLabel: item?.unit_label };
  //             login
  //               ? array[2].plan.push({ ...pricePlan, ...nameObj })
  //               : array[1].plan.push({ ...pricePlan, ...nameObj });
  //           }
  //           return 0;
  //         });
  //       }
  //       return 0;
  //     });
  //     if (login && data?.supportPlans?.metadata?.type === "support_plan") {
  //       data?.supportPlans?.prices?.data?.map((pricePlan) => {
  //         if (pricePlan?.active === true) {
  //           const nameObj = {
  //             name: data?.supportPlans?.name,
  //             unitLabel: data?.supportPlans?.unit_label,
  //           };
  //           array[0].plan.push({ ...pricePlan, ...nameObj });
  //         }
  //         return 0;
  //       });
  //     }
  //     setsubscriptionlist(array);
  //     setSupportPlan(data?.supportPlans);
  //     setSelectedPeriodPlan(login ? array[1] : array[0]);
  //     setPromoCode(data.coupons);
  //     data.coupons &&
  //       data.coupons?.length > 0 &&
  //       data.coupons?.map((el) => {
  //         el?.id === "FIRST50" && setDefaultPromoCode(el?.id);
  //         return 0;
  //       });

  //     setIsSubLoading(false);
  //   } catch (error) {
  //     setIsSubLoading(false);
  //   }
  // }, [login]);

  // useEffect(() => {
  //   setsubscriptiondata();
  // }, [setsubscriptiondata]);
  // *API Call of Subscription Products - End

  const handleDelete = () => {
    fetchProjects(limit, page);
  };

  const handleXeroModal = () => {
    setIsImportFromXero(!isImportFromXero);
  };

  const handlexero = async () => {
    try {
      setProjectLoading(true);
      // const formData = new FormData();
      // if (builderId) {
      //   formData.append("builder_id", builderId);
      // }
      // formData.append("builder_id", builderId);
      // const response = await fileUpload(`${API.XERO_REFRESH}`, formData);
      setProjectLoading(false);
      // if (response?.data?.status === 200) {
      try {
        setProjectLoading(true);
        const response = await get(
          `${API.XERO_TENANTS}${builderId && "?builder_id=" + builderId}`
        );
        setProjectLoading(false);
        if (response?.data?.status === 200) {
          toast.success(response?.data?.message);
          setIsTenantData(true);
          let tenantList = response?.data?.data?.map((item) => {
            const { tenantId: value, ...rest } = item;
            return {
              label: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {item?.tenantName}{" "}
                  {/* <span
                      style={
                        item?.is_active
                          ? {
                              background: "#0DA500",
                              color: "white",
                              marginLeft: "auto",
                              padding: "4px 6px",
                              borderRadius: "5px",
                              marginRight: "5px",
                            }
                          : {
                              background: "#F00",
                              color: "white",
                              marginLeft: "auto",
                              padding: "4px 6px",
                              borderRadius: "5px",
                              marginRight: "5px",
                            }
                      }
                    >
                      {item?.is_active ? "Active" : "InActive"}
                    </span> */}
                </div>
              ),
              value,
              ...rest,
            };
          });
          setTenantId(tenantList[0]);
          setTenantData(tenantList);
        }
      } catch (error) {
        setProjectLoading(false);
        handleXeroModal();
        // toast.error(error?.message);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
      // }
    } catch (e) {
      setProjectLoading(false);
      try {
        setProjectLoading(true);
        // const formData = new FormData();
        // if (builderId) {
        //   formData.append("builder_id", builderId);
        // }
        // formData.append("builder_id", builderId);
        // const response = await fileUpload(`${API.XERO_REFRESH}`, formData);
        setProjectLoading(false);
        // if (response?.data?.status === 200) {
        try {
          setProjectLoading(true);
          const response = await get(
            `${API.XERO_TENANTS}${builderId && "?builder_id=" + builderId}`
          );
          setProjectLoading(false);
          if (response?.data?.status === 200) {
            setIsTenantData(true);
            let tenantList = response?.data?.data?.map((item) => {
              const { tenantId: value, ...rest } = item;
              return {
                label: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {item?.tenantName}{" "}
                    {/* <span
                        style={
                          item?.is_active
                            ? {
                                background: "#0DA500",
                                color: "white",
                                marginLeft: "auto",
                                padding: "4px 6px",
                                borderRadius: "5px",
                                marginRight: "5px",
                              }
                            : {
                                background: "#F00",
                                color: "white",
                                marginLeft: "auto",
                                padding: "4px 6px",
                                borderRadius: "5px",
                                marginRight: "5px",
                              }
                        }
                      >
                        {item?.is_active ? "Active" : "InActive"}
                      </span> */}
                  </div>
                ),
                value,
                ...rest,
              };
            });
            setTenantId(tenantList[0]);

            setTenantData(tenantList);
          }
        } catch (error) {
          setProjectLoading(false);
          handleXeroModal();
          // const errors = error.response?.data?.errors;
          // Object.keys(errors).forEach((key) => {
          //   toast.error(errors[key][0]);
          // });
          // toast.error(error?.message);
          if (error?.response?.data?.errors) {
            Object.keys(error?.response?.data?.errors).forEach((key) => {
              toast.error(error?.response?.data?.errors[key][0]);
            });
          } else {
            toast.error(error?.message);
          }
        }
        // }
      } catch (error) {
        setProjectLoading(false);
        handleXeroModal();
        toast.error("Something went wrong");
        // const errors = error.response?.data?.errors;
        // Object.keys(errors).forEach((key) => {
        //   toast.error(errors[key][0]);
        // });
      }
    }
    // window.open(xeroURl, '_self');
  };

  const handleImportModal = async () => {
    try {
      setProjectLoading(true);
      const response = await fetchAccountConnectionData(builderId);
      setProjectLoading(false);
      setXeroData(response?.xero_integration_data);
    } catch (e) {
      setProjectLoading(false);
    } finally {
      setShowImport(true);
    }
  };

  const handleImportClose = () => {
    setShowImport(false);
  };

  const handleSubmiTenantData = async (id) => {
    if (id) {
      try {
        setProjectLoading(true);
        setXPMLoading(true);
        const formData = new FormData();
        formData.append("xero_tenant_id", id ? id?.value : "");
        formData.append("builder_id", builderId ? builderId : "");
        const xeroClients = await fileUpload(`${API.XERO_PROJECT}`, formData);
        setProjectLoading(false);
        setXPMLoading(false);
        if (xeroClients?.data?.status === 200) {
          toast.success(
            <>
              <p>{xeroClients?.data?.message}</p>
              <p>{xeroClients?.data?.data?.message}</p>
            </>
          );
          handleTenantModal();
          handleXeroModal();
          handleImportClose();
          fetchProjects(limit, page);
        }
      } catch (e) {
        setProjectLoading(false);
        handleTenantModal();
        handleXeroModal();
        handleImportClose();
        setXPMLoading(false);
        const errors = e.response?.data?.errors;
        Object.keys(errors).forEach((key) => {
          toast.error(errors[key][0]);
        });
        // toast.error(e?.message);
        // toast.error(e.errors && e.errors.bt_error && e.errors.bt_error[0]);
      }
    }
  };

  const handleTenantModal = () => {
    setTenantId();
    setIsTenantData(!isTenantData);
  };

  useEffect(() => {
    async function fetchData() {
      if (xeroCode) {
        try {
          const formData = new FormData();
          formData.append("code", xeroCode ? xeroCode : "");
          formData.append("builder_id", builderId ? builderId : "");
          const { data } = await fileUpload(
            `${API.XERO_OAUTHREDIRECT}`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          if (data?.status === 200) {
            navigate(`${API.GET_CUSTOMERLIST}?search=&page=1`, {
              replace: true,
            });
            try {
              const formData = new FormData();
              if (builderId) {
                formData.append("builder_id", builderId);
              }
              formData.append("builder_id", builderId);
              const response = await fileUpload(
                `${API.XERO_REFRESH}`,
                formData
              );
              if (response?.data?.status === 200) {
                return null;
              }
            } catch (e) {
              try {
                const formData = new FormData();
                if (builderId) {
                  formData.append("builder_id", builderId);
                }
                formData.append("builder_id", builderId);
                const response = await fileUpload(
                  `${API.XERO_REFRESH}`,
                  formData
                );
                if (response?.data?.status === 200) {
                  return null;
                }
              } catch (error) {
                toast.error("Something went wrong");
                // const errors = error.response?.data?.errors;
                // Object.keys(errors).forEach((key) => {
                //   toast.error(errors[key][0]);
                // });
              }
            }
          }
        } catch (e) {
          const { data } = e.response;
          if (data) {
            toast.error(data?.message);
            toast.error(
              data.errors && data.errors.bt_error && data.errors.bt_error[0]
            );
          }
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [builderId, xeroCode]);

  // *API Call for Geting Projects - Start
  const fetchProjects = useCallback(
    async (passLimit, passPage) => {
      try {
        setProjectLoading(true);
        const { data } = await get(
          `${API.GET_PROJECT}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&builder_id=${id ? id : ""}`
        );
        setProjectLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setHeadProject(data?.head_project);
        const projectList = data.data.data;
        let notSelectedIds = [];
        for (let i = 0; i < projectList?.length; i++) {
          notSelectedIds.push(projectList[i]?.id);
        }
        setNotXeroSelectedRowIds(notSelectedIds);
        setProjectList(projectList);
        return data.data;
      } catch (error) {
        setProjectLoading(false);
        setHeadProject(null);
        setProjectList([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, searchParam, sortOrder, sortField]
  );

  const toggleSingleSyncOptionModal = async (id) => {
    setBuilderProjectId(id);
    if (!syncOptionModal) {
      setProjectLoading(true);
      const response = await fetchAccountConnectionData(builderId);
      setProjectLoading(false);
      if (response?.xero_integration_data?.connection_status === 1) {
        setXeroData(response?.xero_integration_data);
        fetchSyncOptions();
      } else {
        toast.warn("Please connect the xero account");
        return;
      }
    }
    setSyncOptionModal(!syncOptionModal);
  };

  const xeroConnection = async () => {
    setProjectLoading(true);
    const response = await fetchAccountConnectionData(builderId);
    setProjectLoading(false);
    if (response?.xero_integration_data?.connection_status === 1) {
      setXeroData(response?.xero_integration_data);
    } else {
      // toast.warn("Please connect the xero account");
      setXeroData(response?.xero_integration_data);
      return;
    }
  };

  useEffect(() => {
    xeroConnection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync

  const arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  // eslint-disable-next-line no-unused-vars
  const mainSelectRow = {
    mode: "checkbox",
    // hideSelectAll: abaDate ? false : true,
    clickToSelect: false,
    selected: xeroSelectedRowIds,
    nonSelectable:
      xeroData?.connection_status === 1 ? [] : notXeroSelectedRowIds,
    // nonSelectable: notSelectedRowIds,
    onSelectAll: (row, isSelect) => {
      // if (abaDate) {
      if (projectList?.length > 0) {
        if (row) {
          const ids =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect?.map((item) => {
              return item?.key;
            });
          setXeroSelectedRowIds(
            xeroSelectedRowIds ? xeroSelectedRowIds.concat(ids) : ids
          );
        } else {
          const removableData =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect.map(function (data) {
              return data?.key;
            });
          setXeroSelectedRowIds(
            xeroSelectedRowIds
              ? xeroSelectedRowIds.filter(
                  (item) => !removableData.includes(item)
                )
              : []
          );
        }
      }
      // }
    },
    onSelect: (row, isSelect) => {
      // if (abaDate) {
      if (isSelect) {
        setXeroSelectedRowIds((keys) => [...keys, row?.key]);
      } else {
        setXeroSelectedRowIds(arrayRemove(xeroSelectedRowIds, row?.key));
      }
      // } else {
      //   if (isSelect) {
      //     setXeroSelectedRowIds((keys) => [...keys, row?.key]);
      //     setABADate(moment(row?.transaction_date, "DD-MM-YYYY").format("DD-MM-YYYY"));
      //   }
      // }
    },
  };

  const fetchSyncOptions = async () => {
    try {
      setTentantLoading(true);
      const response = await get(
        `${API.XERO_TENANTS}${builderId && "?builder_id=" + builderId}`
      );
      setTentantLoading(false);
      if (response?.data?.status === 200) {
        toast.success(response?.data?.message);
        let tenantList = response?.data?.data?.map((item) => {
          const { tenantId: value, ...rest } = item;
          return {
            label: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {item?.tenantName}{" "}
              </div>
            ),
            value,
            ...rest,
          };
        });
        setSyncOptionId(tenantList[0]);
        setSyncOptionData(tenantList);
      }
    } catch (error) {
      setTentantLoading(false);
      // toast.error(error?.message);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
      } else {
        toast.error(error?.message);
      }
    }
  };

  const toggleSyncOptionModal = async () => {
    if (!xeroSelectedRowIds.length && !builderProjectId) {
      toast.error("Please select rows");
      return;
    }
    if (!syncOptionModal) {
      setProjectLoading(true);
      const response = await fetchAccountConnectionData(builderId);
      setProjectLoading(false);
      if (response?.xero_integration_data?.connection_status === 1) {
        setXeroData(response?.xero_integration_data);
        fetchSyncOptions();
      } else {
        toast.warn("Please connect the xero account");
        return;
      }
    }
    if (syncOptionModal) {
      setSyncOptionId();
    }
    setSyncOptionModal(!syncOptionModal);
  };

  const handleSyncData = async (id) => {
    if (!builderProjectId) {
      if (!xeroSelectedRowIds.length) {
        toast.error("Please select rows");
        return;
      }
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("xero_tenant_id", id ? id?.value : "");
      if (builderProjectId) {
        formData.append(`builder_project_ids[0]`, builderProjectId);
      } else {
        if (xeroSelectedRowIds?.length > 0) {
          for (let i = 0; i < xeroSelectedRowIds?.length; i++) {
            formData.append(`builder_project_ids[${i}]`, xeroSelectedRowIds[i]);
          }
        }
      }
      const { data } = await fileUpload(API.PROJECT_SYNC, formData, {});
      setXeroSelectedRowIds([]);
      setSyncOptionModal(false);
      setBuilderProjectId();
      setLoading(false);
      toast.success(data.message);
      if (data) {
        fetchProjects(limit, page);
      }
    } catch (e) {
      setLoading(false);
      const errors = e?.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  const projectModal = () => {
    fetchProjects(limit, page);
  };

  const toggleProjectModal = () => {
    showProject && projectModal();
    setShowProject(!showProject);
  };
  // *API Call for Geting Projects - End

  // *Projects Table Row and Column Generation, Filtering and Sorting of Record - Start
  const projectGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        builder_id: projectList[i]?.builder_id,
        key: projectList[i]?.id,
        project_id: projectList[i]?.id,
        project_name:
          projectList[i]?.subscription?.status === 0 ||
          projectList[i]?.subscription?.status === 1 ? (
            <Link
              to={{
                pathname: `/projects/${projectList[i]?.id}`,
              }}
              className="project-name-link active"
            >
              {projectList[i]?.project_name}
            </Link>
          ) : (
            projectList[i]?.project_name
          ),
        email: projectList[i]?.email ? projectList[i]?.email : "-",
        phone: projectList[i]?.phone ? formatPhone(projectList[i]?.phone) : "-",
        end_date: projectList[i]?.end_date ? projectList[i]?.end_date : "-",
        address: formatedAddress(
          projectList[i]?.street,
          projectList[i]?.suburb?.name,
          projectList[i]?.state?.short_name,
          projectList[i]?.postal_code
        ),
        reconciled_item: projectList[i]?.reconciled_item
          ? projectList[i]?.reconciled_item
          : "0",
        total_transactions: projectList[i]?.total_transactions
          ? projectList[i]?.total_transactions
          : "0",
        estimated_cost: projectList[i]?.estimated_cost
          ? `$${formatNumber(Number(projectList[i]?.estimated_cost))}`
          : "-",
        status: projectList[i]?.project_status
          ? projectList[i]?.project_status == 2 &&
            projectList[i]?.end_date &&
            new Date(
              projectList[i]?.end_date?.split("-")?.reverse()?.join("-")
            ) < today
            ? "Delayed"
            : ProjectStatus?.find(
                (item) => item?.value === Number(projectList[i]?.project_status)
              )?.label
          : "-",
        import_from: projectList[i]?.import_from
          ? projectList[i]?.import_from
          : "BuildTrust",
        action: (
          <ProjectActionButton
            id={projectList[i]?.id}
            builderId={projectList[i]?.builder_id}
            handleDelete={handleDelete}
            projectModal={projectModal}
            headProject={headProject}
            totalProject={projectList?.length ? projectList?.length : 0}
            toggleSingleSyncOptionModal={toggleSingleSyncOptionModal}
            xeroConnection={xeroData?.connection_status === 1 ? true : false}
          />
        ),
        subscribe: (
          <ProjectSubscriptionStatus
            id={projectList[i]?.id}
            builderId={projectList[i]?.builder_id}
            isSubscribe={projectList[i]?.subscription?.status}
            fetchProjects={projectModal}
            projectName={projectList[i]?.project_name}
          />
        ),
      });
    }
    return items;
  };

  const project = projectGenerator(projectList?.length);

  const ProjectColumns = [
    {
      dataField: "project_name",
      text: "Project Name",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone No.",
      sort: true,
    },
    {
      dataField: "address",
      text: "Project Address",
      // sort: true,
    },
    {
      dataField: "end_date",
      text: "End Date",
      // sort: true,
    },
    // {
    //   dataField: "reconciled_item",
    //   text: "Reconciled Transactions",
    // },
    // {
    //   dataField: "total_transactions",
    //   text: "Total Transactions",
    // },
    {
      dataField: "estimated_cost",
      text: "Estimated Cost",
    },
    {
      dataField: "status",
      text: "Project Status",
    },
    {
      dataField: "import_from",
      text: "Import From",
    },
    {
      dataField: "subscribe",
      text: "Manage",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchProjects(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchProjects(limit, page);
  };
  // *Projects Table Row and Column Generation, Filtering and Sorting of Record - End

  return (
    <>
      <div className="content-details">
        <div className="table-top-btn">
          <SearchBox
            placeholder={"Search Project"}
            searchParamData={searchParamData}
            handleSearchChange={handleSearchChange}
            handleClearSearch={handleClearSearch}
          />
          <div className="table-btn">
            {/* {xeroData?.connection_status === 1 ? (
                  xeroSelectedRowIds?.length === 0 ? (
                    <CustomTooltip message={"Please select record(s) to sync."}>
                      <Button
                        variant="primary"
                        onClick={toggleSyncOptionModal}
                        disabled={true}
                      >
                        Sync
                      </Button>
                    </CustomTooltip>
                  ) : (
                    <CustomTooltip message={"Sync"}>
                      <Button variant="primary" onClick={toggleSyncOptionModal}>
                        Sync
                      </Button>
                    </CustomTooltip>
                  )
                ) : (
                  <CustomTooltip message={"Please connect with xero to sync."}>
                    <Button
                      variant="primary"
                      onClick={toggleSyncOptionModal}
                      disabled={true}
                    >
                      Sync
                    </Button>
                  </CustomTooltip>
                )} */}

            <CustomTooltip
              message={
                xeroData?.connection_status === 0
                  ? "Please connect with xero to import"
                  : "Import Projects"
              }
            >
              <Button
                variant="primary"
                onClick={handleImportModal}
                disabled={xeroData?.connection_status === 0}
              >
                Import Projects
              </Button>
            </CustomTooltip>
            <Button
              variant="primary"
              onClick={() =>
                navigate("/project-import-logs", {
                  state: { builderId: builderId },
                })
              }
            >
              View Import Logs
            </Button>
            <Button
              variant="primary"
              onClick={toggleProjectModal}
              data-toggle="modal"
              data-target="#business"
            >
              Add Project
            </Button>

            {/* <Button variant="primary">Import</Button> */}
          </div>
        </div>
        <div className="custom-table">
          {projectLoading && <Spin />}
          <BootstrapTable
            keyField="project_id"
            remote
            data={project}
            columns={ProjectColumns}
            // selectRow={mainSelectRow}
            onTableChange={handleTableChange}
            noDataIndication="No Data Found"
          />

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>
      </div>
      {showProject && (
        <AddProject
          toggleProjectModal={toggleProjectModal}
          builderId={id}
          projectModal={projectModal}
          showProject={showProject}
          headProject={headProject}
          totalProject={
            projectList && projectList?.length > 0 ? projectList?.length : 0
          }
        />
      )}
      {showImport && (
        <Modal
          size="lg"
          show={showImport}
          onHide={handleImportClose}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Import Project
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* <UploadFile
                projectId={projectId}
                isLoading={isImportLoading}
                setFiles={setFiles}
                files={files}
                handleUpload={handleUpload}
                handleCancel={handleImportClose}
                acceptFileFormat=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              /> */}
              {xeroData?.connection_status === 1 ? (
                <>
                  <h5>Import From</h5>
                  <span className="procore-and-xero">
                    {xeroData?.connection_status === 1 && (
                      <CustomTooltip message={"Xero"}>
                        <span>
                          <img
                            src={XeroLogo}
                            onClick={handleXeroModal}
                            alt="Xero"
                            height={100}
                            width={100}
                          ></img>
                        </span>
                      </CustomTooltip>
                    )}
                  </span>
                </>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
      {isImportFromXero && (
        <Modal
          show={isImportFromXero}
          onHide={handleXeroModal}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Confirmation!
          </Modal.Header>
          <Modal.Body>
            {projectLoading && <Spin />}
            <div className="modal-body ">
              <p>Do you want to import/update project records from Xero?</p>
            </div>
            <div className="modal-footer">
              <Button
                type="Button"
                className="btn btn-secondary"
                onClick={handleXeroModal}
              >
                Cancel
              </Button>
              <Button className="btn btn-primary" onClick={handlexero}>
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {isTenantData && (
        <Modal
          show={isTenantData}
          onHide={handleTenantModal}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="xpm-modal"
        >
          <Modal.Header closeButton>Xero Organisation</Modal.Header>
          <Modal.Body>
            {XPMLoading && <Spin />}
            <div className="modal-body" style={{ textAlign: "center" }}>
              <ReactSelect
                name="tenant_id"
                onChange={(e) => {
                  setTenantId(e);
                }}
                value={tenantData?.find(
                  (item) => item.value === tenantId?.value
                )}
                options={tenantData}
                placeholder="Select Xero Organisation"
                classNamePrefix="selectbox"
                isClearable={false}
                isLoading={projectLoading}
                autoComplete="off"
                onKeyPress={(e) => {
                  e.which === 13 && e.preventDefault();
                }}
              />
            </div>
            <div className="modal-footer">
              <Button className="btn btn-secondary" onClick={handleTenantModal}>
                Cancel
              </Button>
              <Button
                className="btn btn-primary"
                disabled={tenantId ? false : true}
                onClick={() => {
                  handleSubmiTenantData(tenantId);
                }}
              >
                OK
              </Button>
            </div>
            {/* </Spin> */}
          </Modal.Body>
        </Modal>
      )}
      {syncOptionModal && (
        <SyncProject
          syncOptionModal={syncOptionModal}
          toggleSyncOptionModal={toggleSyncOptionModal}
          loading={loading}
          tentantLoading={tentantLoading}
          syncOptionData={syncOptionData}
          syncOptionId={syncOptionId}
          setSyncOptionId={setSyncOptionId}
          handleSyncData={handleSyncData}
        />
      )}
    </>
  );
};
export default Projects;
